"use strict";

exports.__esModule = true;
exports.Homas = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _graphqlRequest = require("graphql-request");
var _baseHistoryFetcher = require("../base-history-fetcher");
var _resolveLinks = require("../utils/resolve-links");
var _getChainType = require("../../utils/get-chain-type");
class Homas extends _baseHistoryFetcher.BaseHistoryFetcher {
  constructor(configs) {
    super(configs);
  }
  async fetch(params) {
    const variables = {
      account: params.address
    };
    const paramsSchema = `$account: String`;
    const filterSchema = `filter: { addressId: { equalTo: $account } }`;
    const requestedRedeemsResultShema = `
      nodes {
        id
        addressId
        amount
        allowFastMatch
        blockNumber
        extrinsic 
        timestamp
      }
    `;
    const redeemRequestedsResultShema = `
      nodes {
        id
        addressId
        amount
        extraFee
        blockNumber
        extrinsic 
        timestamp
      }
    `;
    const mintsResultShema = `
      nodes {
        id
        addressId
        amountStaked
        amountMinted
        stakingCurrencyAmount
        liquidAmountReceived
        liquidAmountAddedToVoid
        blockNumber
        extrinsic 
        timestamp
      }
    `;
    const redeemRequestCancelledsResultShema = `
      nodes {
        id
        addressId
        amount
        blockNumber
        extrinsic 
        timestamp
      }
    `;
    const redeemedsResultShema = `
      nodes {
        id
        addressId
        stakingAmountRedeemed
        liquidAmountDeducted
        blockNumber
        extrinsic 
        timestamp
      }
    `;
    const redeemedByUnbondsResultShema = `
      nodes {
        id
        addressId
        eraIndexWhenUnbond
        liquidAmount
        unbondingStakingAmount
        blockNumber
        extrinsic 
        timestamp
      }
    `;
    const redeemedByFastMatchesResultShema = `
      nodes {
        id
        addressId
        matchedLiquidAmount
        feeInLiquid
        redeemedStakingAmount
        blockNumber
        extrinsic 
        timestamp
      }
    `;
    const result = await (0, _graphqlRequest.request)(this.configs.endpoint, (0, _graphqlRequest.gql)`
        query(${paramsSchema}){
          requestedRedeems(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${requestedRedeemsResultShema}
          }
          redeemRequesteds(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${redeemRequestedsResultShema}
          }
          mints(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${mintsResultShema}
          }
          redeemRequestCancelleds(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${redeemRequestCancelledsResultShema}
          }
          redeemeds(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${redeemedsResultShema}
          }
          redeemedByUnbonds(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${redeemedByUnbondsResultShema}
          }
          redeemedByFastMatches(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${redeemedByFastMatchesResultShema}
          }
        }
      `, variables);
    return this.transform(result);
  }
  transform(data) {
    const {
      liquidToken,
      stakingToken
    } = this.configs.wallet.getPresetTokens();
    const requestedRedeems = data.requestedRedeems.nodes.map(item => {
      return {
        data: item,
        message: this.createRequestedRedeemsMessage(item.amount, liquidToken),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'homa.RequestedRedeem',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const redeemRequesteds = data.redeemRequesteds.nodes.map(item => {
      return {
        data: item,
        message: this.createRequestedRedeemsMessage(item.amount, liquidToken),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'homaLite.RedeemRequested',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const mints = data.mints.nodes.map(item => {
      const staked = item.amountStaked === '0' ? item.stakingCurrencyAmount : item.amountStaked;
      const minted = item.amountMinted === '0' ? item.liquidAmountReceived : item.amountMinted;
      return {
        data: item,
        message: this.createMintsMessage(staked, minted, liquidToken, stakingToken),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'homa.Minted',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const redeemRequestCancelleds = data.redeemRequestCancelleds.nodes.map(item => {
      return {
        data: item,
        message: this.createCamcelledsMessage(item.amount, liquidToken),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'homa.RedeemRequestCancelled',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const redeemeds = data.redeemeds.nodes.map(item => {
      return {
        data: item,
        message: this.createredeemedsMessage(item.stakingAmountRedeemed, item.liquidAmountDeducted, liquidToken, stakingToken),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'homaLite.Redeemed',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const redeemedByUnbonds = data.redeemedByUnbonds.nodes.map(item => {
      return {
        data: item,
        message: this.createRedeemedByUnbondsMessage(item.liquidAmount, item.unbondingStakingAmount, liquidToken, stakingToken),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'homa.RedeemedByUnbond',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const redeemedByFastMatches = data.redeemedByFastMatches.nodes.map(item => {
      return {
        data: item,
        message: this.createFastMatchesMessage(item.matchedLiquidAmount, item.redeemedStakingAmount, liquidToken, stakingToken),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'homa.RedeemedByFastMatch',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    return requestedRedeems.concat(redeemRequesteds).concat(mints).concat(redeemRequestCancelleds).concat(redeemeds).concat(redeemedByUnbonds).concat(redeemedByFastMatches).sort((a, b) => new Date(b.data.timestamp) < new Date(a.data.timestamp) ? -1 : 1).slice(0, 20);
  }
  createRequestedRedeemsMessage(amount, liquidToken) {
    return `Request redeem ${_sdkCore.FixedPointNumber.fromInner(amount, liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.decimals).toNumber(6)} ${liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.display}`;
  }
  createMintsMessage(deposit, receive, liquidToken, stakingToken) {
    return `Stake ${_sdkCore.FixedPointNumber.fromInner(deposit, stakingToken === null || stakingToken === void 0 ? void 0 : stakingToken.decimals).toNumber(6)} ${stakingToken === null || stakingToken === void 0 ? void 0 : stakingToken.display} for ${_sdkCore.FixedPointNumber.fromInner(receive, liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.decimals).toNumber(6)} ${liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.display}`;
  }
  createCamcelledsMessage(amount, liquidToken) {
    return `Cancel redeem with ${_sdkCore.FixedPointNumber.fromInner(amount, liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.decimals).toNumber(6)} ${liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.display}`;
  }
  createredeemedsMessage(receive, deducted, liquidToken, stakingToken) {
    return `Redeem ${_sdkCore.FixedPointNumber.fromInner(receive, stakingToken === null || stakingToken === void 0 ? void 0 : stakingToken.decimals).toNumber(6)} ${stakingToken === null || stakingToken === void 0 ? void 0 : stakingToken.display} from ${_sdkCore.FixedPointNumber.fromInner(deducted, liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.decimals).toNumber(6)} ${liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.display}`;
  }
  createRedeemedByUnbondsMessage(burned, receive, liquidToken, stakingToken) {
    return `UnStake ${_sdkCore.FixedPointNumber.fromInner(burned, liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.decimals).toNumber(6)} ${liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.display} for ${_sdkCore.FixedPointNumber.fromInner(receive, stakingToken === null || stakingToken === void 0 ? void 0 : stakingToken.decimals).toNumber(6)} ${stakingToken === null || stakingToken === void 0 ? void 0 : stakingToken.display}`;
  }
  createFastMatchesMessage(burned, receive, liquidToken, stakingToken) {
    return `UnStake ${_sdkCore.FixedPointNumber.fromInner(burned, liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.decimals).toNumber(6)} ${liquidToken === null || liquidToken === void 0 ? void 0 : liquidToken.display} for ${_sdkCore.FixedPointNumber.fromInner(receive, stakingToken === null || stakingToken === void 0 ? void 0 : stakingToken.decimals).toNumber(6)} ${stakingToken === null || stakingToken === void 0 ? void 0 : stakingToken.display} By Fastmatch`;
  }
}
exports.Homas = Homas;